module.exports = __webpack_public_path__ + "static/media/carolina-herrera-good-girl-big.4650c052.png";